import './Download.scss';

import Button from '../../components/ui/Button';
import Header from './blocks/Header';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import PageLayout from '../../layouts/PageLayout';
import appleStore from '../../assets/images/download-apple-store.svg';
import appleTv from '../../assets/images/apple-tv.png';
import cactusLeft from '../../assets/images/cactus-left.png';
import cactusRight from '../../assets/images/cactus-right.png';
import googlePlay from '../../assets/images/download-google-play.svg';
import ipadOverview from '../../assets/images/top-bar-ipad-overview.png';
import ipadOverviewBottom from '../../assets/images/bottom-bar-ipad-overview.png';
import ipadReadBottom from '../../assets/images/bottom-bar-ipad-read.png';
import ipadReadTop from '../../assets/images/top-bar-ipad-read.png';
import ipadWatch from '../../assets/images/watch-new.webp';
import news from '../../assets/images/news.png';
import notification from '../../assets/images/notificatie.webp';
import { pageView } from '../../scripts/analytics';
import resultsInterim from '../../assets/images/uitslagen-en-tussenstanden.webp';
import scores from '../../assets/images/scores.png';
import topVisual from '../../assets/images/download-top.webp';
import tv2 from '../../assets/images/tv-2.png';
import tvTaylor from '../../assets/images/tv-taylor.png';
import { useEffect } from 'react';

const Download = () => {
    useEffect(() => {
        pageView('download');
    }, []);

    return (
        <PageLayout>
            <Helmet>
                <title>ESPN: Download nu de app en kijk live voetbal!</title>
                <meta
                    name="description"
                    content="Download nu de ESPN-app en kijk direct samenvattingen van je favoriete wedstrijden!"
                />
                <meta
                    property="og:title"
                    content="ESPN: Download nu de app en kijk live voetbal!"
                />
                <meta
                    property="og:description"
                    content="Download nu de ESPN-app en kijk direct samenvattingen van je favoriete wedstrijden!"
                />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={topVisual} />
            </Helmet>
            <Header
                image={topVisual}
                title={
                    <>
                        Altijd en overal
                        <br />
                        live voetbal
                    </>
                }
                subtitle="Download de ESPN-app"
                buttons={[
                    {
                        label: (
                            <img
                                height="40"
                                src={appleStore}
                                alt="Apple Store"
                            />
                        ),
                        link: 'https://play.google.com/store/apps/details?id=com.espn.score_center&hl=nl&gl=US',
                        track: 'compagne:download:apple-store',
                    },
                    {
                        label: (
                            <img
                                height="40"
                                src={googlePlay}
                                alt="Google Play"
                            />
                        ),
                        link: 'https://play.google.com/store/apps/details?id=com.espn.score_center&hl=nl&gl=US',
                        track: 'campagne:download:google-play',
                    },
                ]}
            />

            <section className="summary">
                <div className="container">
                    <div className="text-container">
                        <h2 className="heading heading--medium">
                            Samenvattingen <br />& hoogtepunten
                        </h2>
                        <p className="text">
                            Video’s en samenvattingen van o.a. Eredivisie,
                            Keuken Kampioen Divisie, TOTO KNVB Beker, Azerion
                            Vrouwen Eredivisie, UEFA Europa League en UEFA
                            Conference League
                        </p>
                    </div>
                    <div className="ipad-parallax ipad-overview">
                        <div className="image-container overview">
                            <img
                                className="top-bar"
                                src={ipadOverview}
                                alt="top bar van de ipad"
                            />
                            <picture>
                                <img
                                    className="screenshot image"
                                    src={ipadWatch}
                                    alt="Screenshot van de ESPN-app op een tablet"
                                />
                            </picture>
                            <img
                                className="bottom-bar"
                                src={ipadOverviewBottom}
                                alt="bottom bar van de ipad"
                            />
                        </div>
                    </div>
                </div>
            </section>
            <section className="support">
                <div className="grid-item first">
                    <div className="background">
                        <img
                            src={resultsInterim}
                            alt="Doelpunt van Willem 2 thuis tegen Feyenoord"
                        />
                    </div>
                    <div className="text-container">
                        <h2 className="heading heading--medium heading--white">
                            Bekijk alle uitslagen & tussenstanden
                            <span className="text text--white">
                                van alle belangrijke voetbalcompetities
                            </span>
                        </h2>
                    </div>
                    <div className="image-container">
                        <img
                            src={scores}
                            alt="Een screenshot van de-ESPN app"
                        />
                    </div>
                </div>
                <div className="grid-item second">
                    <div className="text-container">
                        <h2 className="heading heading--medium heading--white">
                            Met alerts mis je niks
                        </h2>
                        <p className="text text--white">
                            Met pushnotificaties mis je niks van je favoriete
                            club.
                        </p>
                    </div>
                    <div className="image-container">
                        <img
                            src={notification}
                            alt="Een screenshot van de ESPN-app"
                        />
                    </div>
                </div>
                <div className="grid-item third">
                    <div className="text-container">
                        <h2 className="heading heading--medium heading--white">
                            Support jouw club
                        </h2>
                        <p className="text text--white">
                            Selecteer je favoriete teams en competities.
                            <br />
                            Zo past de app zich aan naar jouw voorkeuren.
                        </p>
                    </div>
                    <div className="image-container">
                        <img
                            src={tvTaylor}
                            alt="Een screenshot van de ESPN-app"
                        />
                    </div>
                </div>
            </section>
            <section className="read">
                <div className="text-container">
                    <h2 className="heading heading--medium">
                        Blijf op de hoogte van het laatste sportnieuws
                    </h2>
                    <p className="text">
                        Met de officiële ESPN-app blijf je altijd en overal op
                        de hoogte van het laatste sportnieuws.
                    </p>
                </div>
                <div className="ipad-parallax">
                    <div className="image-container read">
                        <img
                            className="top-bar"
                            src={ipadReadTop}
                            alt="top bar van de ipad"
                        />
                        <img
                            src={news}
                            className="image"
                            id="parallax"
                            alt="Een schermafbeelding van de ESPN-app op een tablet"
                        />
                        <img
                            className="bottom-bar"
                            src={ipadReadBottom}
                            alt="bottom bar van de ipad"
                        />
                    </div>
                </div>
            </section>
            <section className="subscription">
                <div className="text-container">
                    <div className="content">
                        <h2 className="heading heading--large heading--white">
                            Nog geen abonnement?
                        </h2>
                        <p className="text text--white">
                            Ga naar{' '}
                            <Link
                                className="text text--white inline-link"
                                to="/abonneren"
                            >
                                espnkijken.nl
                            </Link>{' '}
                            om direct een abonnement af te sluiten via jouw
                            tv-aanbieder.
                        </p>
                        <Button
                            link="/abonneren"
                            type="primary"
                            size="large"
                            align="center"
                            label="Meer informatie"
                        />
                    </div>
                    <div className="image-container">
                        <img
                            src={tv2}
                            className="image"
                            alt="Een doelpunt tijdens een voetbalwedstrijd"
                        />
                    </div>
                    <img
                        src={appleTv}
                        className="image apple-tv hide-large-tablet"
                        alt="Een Apple TV"
                    />
                    <div className="cactusses">
                        <img
                            src={cactusLeft}
                            className="image cactus hide-large-tablet cactus__left"
                            alt="Een cactus"
                        />
                        <img
                            src={cactusRight}
                            className="image cactus hide-large-tablet cactus__right"
                            alt="Een cactus"
                        />
                    </div>
                </div>
            </section>
        </PageLayout>
    );
};

export default Download;
